module.exports = __webpack_public_path__ + "img/chart-line-solid.014e6e8f.svg";